export default __webpack_public_path__ + "resources/icons/n221-826e.webp";